import { Currency, DeliveryStatus, Locale } from '@synergy/models';
import { getLocalizedString } from '@synergy/utils';

import { ArticleListItem } from '../article-list-item';
import { ArticleListItemDto } from '../dto/article-list-item-dto';

export const mapArticleListItem = (
    locales: Locale[],
    currency: Currency,
    article: ArticleListItemDto
): ArticleListItem => {
    const orderUnit = getLocalizedString(locales, article.orderUnit);
    const localizedContentUnit = getLocalizedString(locales, article.contentUnit);
    const isContentUnitSameAsOrderUnit = localizedContentUnit === orderUnit;
    const contentUnit = isContentUnitSameAsOrderUnit ? undefined : localizedContentUnit;
    const contentQuantity = isContentUnitSameAsOrderUnit ? undefined : article.contentQuantity;

    return {
        id: article.id,
        score: article.score,
        deliveryStatus: article.deliveryStatus,
        hasVariants: article.hasVariants,
        isBestPrice: article.isBestPrice,
        isEcoProduct: article.isEcoProduct,
        mainPrice: article.mainPrice[currency] ?? 0,
        previewImage: article.previewImage,
        name: getLocalizedString(locales, article.name),
        number: article.number,
        orderUnit,
        supplier: article.supplier,
        contentQuantity,
        contentUnit,
        priceQuantity: article.priceQuantity ?? 1,
        currentSpecialPrice: article.currentSpecialPrice?.[currency],
        currentSpecialPriceUntil: article.currentSpecialPriceUntil && new Date(article.currentSpecialPriceUntil),
        deliveryTimeInDays: article.deliveryTimeInDays,
        minimumOrderQuantity: article.minimumOrderQuantity ?? article.quantityInterval ?? 1,
        isFavorite: article.isFavorite ?? false, // TODO: remove optionality after backend implementation
        currency,
        canBePurchased:
            article.deliveryStatus !== DeliveryStatus.Unavailable &&
            article.deliveryStatus !== DeliveryStatus.OnRequest,
    };
};
